<app-pcbread-crumb [data]="'DrugStore,RareDrug'"></app-pcbread-crumb>

<div class="card p-2 animate__animated animate__backInDown">
  <app-pctable-action
    [data]="action"
    [header]="fields"
    (parentAction)="parentAction($event)"
  >
  </app-pctable-action>

  <app-pctable
    [data]="data"
    [entityField]="fields"
    (parentAction)="parentAction($event)"
  >
  </app-pctable>

  <app-pcpaging [paging]="paging" (parentAction)="parentAction($event)">
  </app-pcpaging>

  <app-loading-panel *ngIf="loading"> </app-loading-panel>
</div>

<app-pcsuccess-modal
  [showModal]="modalSuccessConfirm"
  (parentAction)="parentAction($event)"
>
</app-pcsuccess-modal>

<app-pcconfrim-modal
  *ngIf="modalDeleteConfirm"
  (childEvent)="parentAction($event)"
  [inputModel]="confirmModal"
></app-pcconfrim-modal>

<app-pcsetting-modal (parentAction)="parentAction($event)" [fields]="fields">
</app-pcsetting-modal>

<!--#region EditModal Modal-->
<ng-template #EditModal let-modal class="modal modal-top fade">
  <div class="modal-header border-bottom p-3">
    <h6 id="offcanvasAddUserLabel" class="offcanvas-title">
      {{ "Add" | translate }}
    </h6>
    <button
      type="button"
      class="btn-close-modal btn-icon btn-close"
      (click)="modal.dismiss('Cross click')"
      aria-label="Close"
    ></button>
  </div>

  <div class="modal-body border-bottom">
    <div class="row">
      <div class="col-12">
        <div
          class="edit-form"
          appClickOutside
          (clickOutside)="modalIsOpen = false"
        >
          <label class="form-label" for="ProductBrandName">
            {{ "ProductBrandName" | translate }}
          </label>
          <div class="validation-alert-sale-buy">
            <p *ngIf="thisValue.brandNameValidation">
              {{ thisValue.brandNameValidation | translate }}
            </p>
          </div>
          <div class="input-group input-daterange">
            <input
              type="text"
              autocomplete="off"
              class="form-control Focusable iner-Focusable search-input-box"
              placeholder="{{ 'genericCode' | translate }}"
              appSelectOnFocus
              [(ngModel)]="thisValue.genericCode"
              (keyup.Enter)="searchDrugByGeneric()"
              (keyup.escape)="modalIsOpen = false"
            />
            <input
              id="drugBrandName"
              type="text"
              autocomplete="off"
              appSelectOnFocus
              class="form-control Focusable iner-Focusable search-input-box w-50"
              placeholder="{{ 'SearchAndScanBarcode' | translate }}"
              [(ngModel)]="thisValue.brandName"
              (keyup.Enter)="searchDrug()"
              [ngClass]="{
                'is-invalid':
                  thisValue.brandNameValidation != '' &&
                  thisValue.brandNameValidation != null
              }"
              (keyup.escape)="modalIsOpen = false"
            />
            <button
              class="input-group-text"
              type="button"
              ngbTooltip="{{ 'ScanBarcode' | translate }}"
              (click)="openCamera()"
            >
              <i class="bx bx-barcode-reader"></i>
            </button>
          </div>
          <app-search-box
            [data]="searchData"
            [right]="'-100%'"
            [leftTriangle]="'65%'"
            [addButton]="false"
            [fields]="searchFields"
            [urlName]="'columnsArray_rareDrugSearch'"
            [paging]="searchPaging"
            [modalIsOpen]="modalIsOpen"
            (parentAction)="parentSearchAction($event)"
          ></app-search-box>
        </div>
      </div>
      <div class="col-6 mt-2">
        <label class="form-label" for="Number">
          {{ "maxSaleQuantity" | translate }}
        </label>
        <input
          #count
          id="maxSaleQuantity"
          type="text"
          autocomplete="off"
          appSelectOnFocus
          class="form-control input-one Focusable iner-Focusable"
          [(ngModel)]="thisValue.maxSaleQuantity"
          appConvertNumbers
          mask="separator.0"
          thousandSeparator=","
          [ngClass]="{
            'is-invalid':
              thisValue.maxSaleQuantityValidation != '' &&
              thisValue.maxSaleQuantityValidation != null
          }"
        />
      </div>
      <div class="col-6 mt-2">
        <label class="form-label" for="Number">
          {{ "minInvoiceAmount" | translate }}
        </label>
        <input
          #count
          id="minInvoiceAmount"
          type="text"
          autocomplete="off"
          appSelectOnFocus
          class="form-control input-one Focusable iner-Focusable"
          [(ngModel)]="thisValue.minInvoiceAmount"
          appConvertNumbers
          mask="separator.0"
          thousandSeparator=","
          [ngClass]="{
            'is-invalid':
              thisValue.minInvoiceAmountValidation != '' &&
              thisValue.minInvoiceAmountValidation != null
          }"
        />
      </div>
      <div class="col-6 mt-2">
        <label class="form-label" for="Number">
          {{ "percentageSaleAmount" | translate }}
        </label>
        <input
          #count
          id="percentageSaleAmount"
          type="text"
          autocomplete="off"
          appSelectOnFocus
          class="form-control input-one Focusable iner-Focusable"
          [(ngModel)]="thisValue.percentageSaleAmount"
          appConvertNumbers
          mask="separator.0"
          thousandSeparator=","
          [ngClass]="{
            'is-invalid':
              thisValue.percentageSaleAmountValidation != '' &&
              thisValue.percentageSaleAmountValidation != null
          }"
        />
      </div>
    </div>
  </div>

  <div class="modal-footer justify-content-center p-2">
    <button type="button" class="btn btn-outline-primary" (click)="submitAdd()">
      <i class="bx bx-plus"></i>
      {{ "Add" | translate }}
    </button>
    <button
      type="button"
      class="btn btn-light"
      (click)="modal.dismiss('Cross click')"
    >
      <i class="bx bx-x"></i>
      {{ "Close" | translate }}
    </button>
  </div>
  <app-loading-panel *ngIf="loading"></app-loading-panel>
</ng-template>
<!--#endregion -->

<app-barcode-scanner
  #barcodeScanner
  (parentAction)="handleScannedBarcode($event)"
></app-barcode-scanner>
